import type { SVGProps } from 'react'
const LineCrown = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M22 20H2V5.955c0-.505.305-.96.77-1.155a1.24 1.24 0 0 1 1.36.27l3.24 3.24 3.74-3.74a1.26 1.26 0 0 1 1.77 0l3.74 3.74 3.24-3.24a1.249 1.249 0 0 1 2.13.885V20zM3.5 18.5h17V6.56l-3.875 3.875L12 5.81l-4.625 4.625L3.5 6.56z"
		/>
	</svg>
)
export { LineCrown }
